module.exports = __webpack_public_path__ + "img/success.de4ee7ad.svg";